import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface ContactDialogData {
  contact?: any;
  customerId: number;
}

@Component({
  selector: 'app-contact-dialog',
  templateUrl: './contact-dialog.component.html',
})
export class ContactDialogComponent implements OnInit {
  form!: FormGroup;
  saving = false;
  formError = '';
  isEdit = false;
  readonly contactRoles = ['DecisionMaker', 'Champion', 'Billing', 'Technical', 'Operations', 'Other'];

  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ContactDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ContactDialogData,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.isEdit = !!this.data.contact;
    const c = this.data.contact;
    this.form = this.fb.group({
      firstName:   [c?.firstName ?? '', [Validators.required, Validators.maxLength(64)]],
      lastName:    [c?.lastName ?? '',  [Validators.required, Validators.maxLength(64)]],
      displayName: [c?.displayName ?? '', Validators.maxLength(128)],
      phone:       [c?.phone ?? '',     Validators.maxLength(32)],
      email:       [c?.email ?? '',     [Validators.email, Validators.maxLength(128)]],
      title:       [c?.title ?? '',     Validators.maxLength(64)],
      isPrimary:   [c?.isPrimary ?? false],
      contactRole: [c?.contactRole ?? 'Other'],
      notes:       [c?.notes ?? '',     Validators.maxLength(2000)],
    });
  }

  submit(): void {
    if (this.form.invalid) return;
    this.saving = true;
    this.formError = '';
    const payload = { ...this.form.value, customerId: this.data.customerId };
    const req = this.isEdit
      ? this.http.put(`/api/contacts/${this.data.contact.id}`, payload)
      : this.http.post('/api/contacts', payload);

    req.subscribe({
      next: () => {
        this.saving = false;
        this.snackBar.open(this.isEdit ? 'Contact updated.' : 'Contact added.', undefined, { duration: 2500 });
        this.dialogRef.close(true);
      },
      error: (e: any) => {
        this.saving = false;
        if (e?.status === 409) {
          this.formError = 'Another contact is already marked as primary. Uncheck theirs first.';
          this.form.get('isPrimary')?.setErrors({ conflict: true });
        } else {
          this.snackBar.open(e?.error?.message ?? 'Failed to save contact.', 'OK', { duration: 5000 });
        }
      }
    });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
